"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNSORTED = exports.PRODUCTS_SORTING_TYPE = void 0;
exports.PRODUCTS_SORTING_TYPE = {
    FEATURED: 'FEATURED',
    CREATED_AT: 'CREATED_AT',
    SALES: 'SALES',
    TRENDING: 'TRENDING',
    DISCOUNT: 'DISCOUNT'
};
exports.UNSORTED = 0;
//# sourceMappingURL=productSortingType.js.map